import type { ShortCode } from '@highereducation/wordpress';
import { EmbedClient } from './EmbedClient';
import type { EmbedShortcodeProps } from './types';

export { EmbedClient } from './EmbedClient';
export type { EmbedShortcodeProps, EmbedProvider } from './types';

/**
 * EmbedShortcode — `[hen-ui-embed]`
 *
 * A single generic shortcode that renders BestColleges' third-party embeds
 * (Everviz, YouTube, Twitter/X, Instagram, TikTok) reliably through the HEN
 * content pipeline. Editors author embeds directly as `[hen-ui-embed]`
 * shortcodes; raw third-party markup is intentionally not auto-converted.
 *
 * Supported attributes:
 * - provider: youtube | everviz | twitter | instagram | tiktok | generic
 * - src / url: iframe or permalink URL
 * - id: provider id (X status id, Everviz chart id, YouTube video id)
 * - title: accessibility label
 * - aspect-ratio: e.g. "16:9" (iframe providers)
 *
 * @example
 * [hen-ui-embed provider="youtube" src="https://www.youtube.com/embed/ID"]
 * [hen-ui-embed provider="twitter" id="1234567890"]
 * [hen-ui-embed provider="everviz" id="abc123"]
 */
export const EmbedShortcode: ShortCode<EmbedShortcodeProps> = {
  component: EmbedClient,
};
